import type { ReactNode } from "react";
import { CertificationFilters } from "@modules/certificaciones/shared/ui";

type Props = {
  title: string;
  count: number;
  onReset: () => void;
  children: ReactNode;
  actions?: ReactNode;
};

export function Iso900114001Filters({
  title,
  count,
  onReset,
  children,
  actions,
}: Props) {
  return (
    <CertificationFilters
      title={title}
      visibleCount={count}
      onReset={onReset}
      actions={actions}
    >
      {children}
    </CertificationFilters>
  );
}
